import {
  FETCH_CAPTCHA_SUCCESS,
  VALIDATE_CAPTCHA_ANSWER_SUCCESS,
  NULLIFY_CAPTCHA,
} from '../actions/captcha-actions';
import { CREATE_POST_SUCCESS, CREATE_POST_FAILURE } from '../actions/create-post';
import { CREATE_COMMENT_SUCCESS, CREATE_COMMENT_FAILURE } from '../actions/create-comment';

const initialState = { svg: null, id: null, answer: null, isCorrect: null };

export function captcha(state = initialState, action) {
  switch (action.type) {
    case FETCH_CAPTCHA_SUCCESS: {
      return action.payload;
    }
    case VALIDATE_CAPTCHA_ANSWER_SUCCESS: {
      return { ...state, ...action.payload };
    }
    case NULLIFY_CAPTCHA:
    case CREATE_POST_SUCCESS:
    case CREATE_POST_FAILURE:
    case CREATE_COMMENT_SUCCESS:
    case CREATE_COMMENT_FAILURE: {
      return initialState;
    }
    default:
      return state;
  }
}
